import React from "react";
import styled from "styled-components";

import SectionHeader from "./SectionHeader";

interface CardProps {
  color: string;
}

const Card = (props: any) => {
  const { className, title, color, children } = props;
  return (
    <Wrapper>
      {title && <SectionHeader title={title} fontSize={22} />}
      <Container className={className} color={color}>
        {children}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Container = styled.div<CardProps>`
  font-family: HelveticaNeue-Medium;
  background: ${(p) => p.color};
  margin-bottom: 44px;
  height: 100%;
`;

export default Card;
